import React, { useCallback } from "react";

import TableControlButton from "./TableControlButton";
import Select from "common-ui-components/components/select";

import bulkOptionsIcon from "../../icons/bulk-options.svg";
import { useTableManagerContext } from "../TableManagerContext";
import { notify } from "common-ui-components/components/notification/Notification";
import { Failure } from "common-ui-components/components/notification/templates";

const BulkOptions = ({ handleAction }) => {
  const { bulkOptionsConfig, setTableControls, selectOptions } =
    useTableManagerContext();

  const handleBulkOptionsSelect = (option, index) => {
    const { selectedRecords } = selectOptions;
    if (selectedRecords.length === 0) {
      notify(
        <Failure>Select at least one record to perform bulk action</Failure>
      );
      return;
    }
    const action = bulkOptionsConfig[index].action;
    action(selectedRecords);
  };

  const handleBulkOptionsClose = useCallback(() => {
    setTableControls((prevTableControls) => ({
      ...prevTableControls,
      bulkOptions: false,
    }));
  }, [setTableControls]);

  if (!bulkOptionsConfig) return null;
  const options = bulkOptionsConfig.map((config) => config.option);

  return (
    <Select
      triggerComponent={TableControlButton}
      triggerProps={{
        name: "Bulk Options",
        icon: bulkOptionsIcon,
        control: "bulkOptions",
        handleAction,
        withoutButton: true,
      }}
      active={-1}
      options={options}
      onClose={handleBulkOptionsClose}
      onOptionSelect={handleBulkOptionsSelect}
    />
  );
};

export default BulkOptions;
